import script from "./EDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EDialog.vue?vue&type=script&setup=true&lang=ts"

import "./EDialog.vue?vue&type=style&index=0&id=0c993421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c993421"]])

export default __exports__